import {AxiosInstance, AxiosRequestConfig} from "axios";

export function createAxiosHelper<T>(
    axios: AxiosInstance,
    respHandler: (data: T) => any,
) {
    const cacheMap: { [key: string]: { data: any, cachedTime: number } } = {};

    axios.interceptors.request.use((config) => {

        return config;
    })


    async function request(reqFunc: any, path: string, params?: any, cacheTime = -1, reqKey?: string) {
        if (cacheTime > 0) {
            let key = `${path}-${JSON.stringify(params)}`;
            if (cacheMap[key]) {
                const {data, cachedTime} = cacheMap[key];
                if (Date.now() - cachedTime < cacheTime) {

                    if (data && reqKey && typeof data === 'object') {
                        data.reqKey = reqKey;
                    }

                    return data;
                }
            }
        }

        let resp: any = null;

        try {
            resp = await reqFunc()
        } catch (e) {
            console.error(e)
        }

        if (!resp) {
            throw new Error(resp)
        }


        if (resp.status !== 200) {
            // throw new Error(`Failed to get ${path}: ${resp.status}`)
            throw new Error(resp.status)
        }

        return await resp.data;
    }

    return {
        get: async (path: string, params?: any, axiosConfig?: AxiosRequestConfig, cacheTime = -1) => {
            if (params) {
                for (const pathKey in params) {
                    if (typeof params[pathKey] === 'object') {
                        params[pathKey] = JSON.stringify(params[pathKey])
                    }
                }
            }

            return request(() => axios.get(path, {
                params,
                ...axiosConfig,
            }), path, params, cacheTime)
        },

        post: async (path: string, params?: any, axiosConfig?: AxiosRequestConfig, cacheTime = -1, reqKey?: string) => {
            return request(
                () => axios.post(path, params, axiosConfig),
                path,
                params,
                cacheTime, reqKey)
        }
    }
}

